import axios from "~/plugins/axios";

export default {
  paginate(
    includes = [],
  ) {
    return axios.get("/web_api/v1/dynamic_extending_search", {
      params: {
        includes,
      },
    })
      .then((response) => response.data);
  },
  paginateBySearch(searchId, includes = []) {
    return axios.post("/web_api/v1/dynamic_extending_search/by_search", { searchId }, {
      params: {
        includes,
      },
    })
      .then((response) => response.data);
  },
  paginateByModel(model, includes = []) {
    return axios.post("/web_api/v1/dynamic_extending_search/by_model", { model }, {
      params: {
        includes,
      },
    })
      .then((response) => response.data);
  },
  getDynamicExtendingSearchesByIds(dynamicExtendingSearchIds, includes = []) {
    return axios.post("/web_api/v1/dynamic_extending_search/by_ids", { ids: dynamicExtendingSearchIds }, {
      params: {
        includes,
      },
    })
      .then((response) => response.data);
  },
};
